import { TrendingUp, Zap, Droplet } from 'lucide-react';
import { Link } from 'react-router-dom';

export function Hero() {
  return (
    <div className="bg-[#008751] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
        <div className="text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6">
            Nigeria's Complete Energy Information Hub
          </h1>

          <p className="text-xl sm:text-2xl mb-8 text-white max-w-3xl mx-auto">
            Power Grids • Renewable Energy • Oil & Gas Refining
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center mb-10">
            <Link
              to="/solar-quotes"
              className="bg-white text-[#008751] px-6 py-3 rounded-lg font-bold hover:bg-gray-100 transition-colors"
            >
              Get Solar Quotes
            </Link>
            <Link
              to="/tools"
              className="bg-[#005c38] border border-[#005c38] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#004a2d] transition-colors"
            >
              Use Energy Tools
            </Link>
          </div>

          {/* <p className="text-lg mb-12 text-white/80 max-w-2xl mx-auto">
            Your single source for electricity tariffs, solar solutions, refinery updates, and interactive tools to manage Nigeria's energy challenges.
          </p> */}

          {/* Quick Stats */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-4xl mx-auto">
              <div className="bg-white/10 rounded-xl p-6">
              <div className="text-3xl font-bold mb-2">4.3 GW</div>
              <div className="text-sm text-white">Average Grid Capacity</div>
            </div>
              <div className="bg-white/10 rounded-xl p-6">
              <div className="text-3xl font-bold mb-2">45%</div>
              <div className="text-sm text-white">Population Grid Access</div>
            </div>
              <div className="bg-white/10 rounded-xl p-6">
              <div className="text-3xl font-bold mb-2">700k bpd</div>
              <div className="text-sm text-white">Dangote Refinery Capacity</div>
            </div>
          </div>
        </div>
      </div>

      {/* Wave Divider */}
      <div className="relative h-16 bg-white">
        <svg
          className="absolute top-0 left-0 w-full h-16"
          viewBox="0 0 1440 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
        >
          <path
            d="M0 48H1440V0C1440 0 1080 48 720 48C360 48 0 0 0 0V48Z"
            fill="#008751"
          />
        </svg>
      </div>
    </div>
  );
}
